module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-item has-dropdown",
    class: {
      'is-active': _vm.show_notifications
    }
  }, [(!_vm.user.data.notifications_nb) ? _c('div', [_c('a', {
    ref: "btn1",
    staticClass: "button is-light is-flat is-bell",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.getNotifications($event)
      }
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.user.data.notifications_nb) ? _c('div', [_c('a', {
    ref: "btn2",
    staticClass: "button is-danger is-flat is-bell",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.getNotifications($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.user.data.notifications_nb) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_notifications),
      expression: "show_notifications"
    }],
    staticClass: "navbar-dropdown"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "is-loader"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('loading')) + "\n    ")]), _vm._v(" "), (!_vm.loading && !_vm.notifications.length) ? _c('li', {
    staticClass: "is-loader"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('empty')) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
    return _c('notification', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loading),
        expression: "!loading"
      }],
      key: notification.id,
      attrs: {
        "item": notification
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notifications")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d07d2a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/List.vue
// module id = 354
// module chunks = 9